import * as types from '../../action-types';
import {dealsDetails as initialState } from "../../initialState";

const dealsDetails = (state=initialState, action) => {
  switch (action.type) {
    case types.DEALS_DETAILS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.DEALS_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.DEALS_DETAILS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.DEALS_DETAILS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default dealsDetails;
